module.exports = __webpack_public_path__ + "static/media/19.22672e1b.jpg";